import { createContext, useContext, useState } from 'react';

import type { Dispatch, ReactNode, SetStateAction } from 'react';

export const SubNavControllerContext = createContext<
  [number, Dispatch<SetStateAction<number | null>>]
>([0, () => null]);

interface SubNavControllerProps {
  children: ReactNode;
}

export const SubNavControllerContextProvider = ({
  children,
}: SubNavControllerProps) => {
  const selected = useState<number | null>(null);

  return (
    <SubNavControllerContext.Provider value={selected}>
      {children}
    </SubNavControllerContext.Provider>
  );
};

export const useSubNavControllerContext = () => {
  return useContext(SubNavControllerContext);
};
